import { BREAKPOINTS } from '../config';

import { lenis } from '../layout/lenis';

const fintech = document.querySelector('.fintech');
const fintechBody = document.querySelector('.fintech__body');

function initScrollFintech() {
  if (!fintech || !fintechBody || !lenis) return;

  const stepsCount = 3;
  let lastIndex = -1;

  const clearSteps = () => {
    for (let i = 1; i <= stepsCount; i++) {
      fintechBody.classList.remove(`step-${i}`);
    }
    lastIndex = -1;
  };

  const setAllSteps = () => {
    for (let i = 1; i <= stepsCount; i++) {
      fintechBody.classList.add(`step-${i}`);
    }
    lastIndex = stepsCount - 1;
  };

  lenis.on('scroll', ({ scroll }) => {
    // if (window.innerWidth <= BREAKPOINTS.mqTouch) return;

    const rect = fintech.getBoundingClientRect();
    const sectionTop = rect.top + scroll;
    const sectionHeight = fintech.offsetHeight;
    const viewportHeight = window.innerHeight;

    const start = sectionTop;
    const end = sectionTop + sectionHeight - viewportHeight;

    // 1. ДО СЕКЦІЇ
    if (scroll < start) {
      clearSteps();
      return;
    }

    // 2. ПІСЛЯ СЕКЦІЇ
    if (scroll > end) {
      setAllSteps();
      return;
    }

    const progress = scroll - start;
    const stepSize = (sectionHeight - viewportHeight) / stepsCount;

    const index = Math.min(stepsCount - 1, Math.floor(progress / stepSize));

    if (index === lastIndex) return;

    // Скрол вниз
    if (index > lastIndex) {
      for (let i = lastIndex + 1; i <= index; i++) {
        const step = i + 1;
        fintechBody.classList.add(`step-${step}`);

        if (step === 2) {
          fintechBody.classList.remove('move-out');
          fintechBody.classList.add('move-in');
        }
      }
    }

    // Скрол вверх
    if (index < lastIndex) {
      for (let i = lastIndex; i > index; i--) {
        const step = i + 1;
        fintechBody.classList.remove(`step-${step}`);

        if (step === 2) {
          fintechBody.classList.remove('move-in');
          fintechBody.classList.add('move-out');
        }
      }
    }

    lastIndex = index;
  });
}

document.addEventListener('DOMContentLoaded', initScrollFintech);
